import { db } from '../firebase/config';
import { collection, addDoc, Timestamp } from 'firebase/firestore';

const missedSubscribers = [
  {
    email: 'iamrodism@gmail.com',
    originalAttemptDate: new Date('2025-02-22T15:09:30-06:00'),
    source: 'historical_subscription'
  },
  {
    email: 'cliffelrod@gmail.com',
    originalAttemptDate: new Date('2025-02-23T09:15:48-06:00'),
    source: 'historical_subscription'
  }
];

export const addMissedSubscribers = async () => {
  const results = [];
  
  for (const subscriber of missedSubscribers) {
    try {
      const docRef = await addDoc(collection(db, 'subscribers'), {
        email: subscriber.email.toLowerCase(),
        status: 'active',
        source: subscriber.source,
        subscriptionDate: Timestamp.fromDate(subscriber.originalAttemptDate),
        restoredFromError: true,
        restorationDate: Timestamp.now()
      });
      
      console.log(`Successfully added subscriber ${subscriber.email} with ID:`, docRef.id);
      results.push({ email: subscriber.email, success: true, id: docRef.id });
    } catch (error) {
      console.error(`Error adding subscriber ${subscriber.email}:`, error);
      results.push({ email: subscriber.email, success: false, error: error.message });
    }
  }
  
  return results;
}; 